/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ListCheckRegularV6 = (props) => (
  <Icon {...props} name="List Check Regular V6">
    <path d="M2.558 4.753a.643.643 0 0 1-.538.219.587.587 0 0 1-.55-.219L.22 3.503c-.293-.266-.293-.741 0-1.033s.768-.293 1.061 0l.691.69 1.722-1.911a.75.75 0 1 1 1.112 1.003L2.557 4.753zm0 5a.643.643 0 0 1-.538.219.587.587 0 0 1-.55-.219L.22 8.503c-.293-.266-.293-.741 0-1.034a.754.754 0 0 1 1.061 0l.691.691 1.722-1.912a.75.75 0 0 1 1.112 1.006l-2.249 2.5zM6.75 3.75a.749.749 0 1 1 0-1.5h8.5a.749.749 0 1 1 0 1.5h-8.5zM6 8c0-.416.334-.75.75-.75h8.5c.416 0 .75.334.75.75s-.334.75-.75.75h-8.5A.748.748 0 0 1 6 8zm-1 5c0-.416.334-.75.75-.75h9.5c.416 0 .75.334.75.75s-.334.75-.75.75h-9.5A.748.748 0 0 1 5 13zm-3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
  </Icon>
);

export default ListCheckRegularV6;
